import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Dialog from 'components/ContextDialog';
import { getLiteral } from 'utils/getLiteral';
import { CancelIcon } from '../../../components/icons';
import styles from './DefaultErrorDialog_styles';
import './DefaultErrorDialog_styles.scss';
import { ButtonPrimary } from '../../../components/buttons';

class DefaultErrorDialog extends Component {
    state = {};

    _renderTitleDialog = () => {
        let { title } = this.props;
        title = title ? title : 'title_warning';
        return (
            <div className="modal-default-error-header">
                {getLiteral(title)}
                <CancelIcon onClick={() => this.onClose()} />
            </div>
        );
    };

    onClose = () => {
        const { onClose } = this.props;
        onClose && onClose();
    };

    render() {
        const { show, onClose, children } = this.props;
        let actions = [
            <ButtonPrimary onClick={onClose}>{getLiteral('action_accept')}</ButtonPrimary>,
        ];
        return (
            <Dialog
                title={this._renderTitleDialog()}
                open={show}
                onRequestClose={this.onClose}
                className="modal-default-error dialogBlockOutsideClick"
                titleClassName="header-dialog"
                bodyClassName="modal-default-error-body"
                bodyStyle={styles.bodyStyle}
                titleStyle={styles.titleDialog}
                actions={actions}
                actionsContainerStyle={styles.actions}
                actionsContainerClassName="modal-default-error-actions"
            >
                {children}
            </Dialog>
        );
    }
}

DefaultErrorDialog.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.string,
};

export default DefaultErrorDialog;
